module.exports = __webpack_public_path__ + "img/sght.88075e7b.png";